import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { volumes, bonuses } from '../data/content';
import { PRICE } from '../config/site';
import { CTAButton } from './CTAButton';
import { DailyCountdown } from './DailyCountdown';
export function OfferStack() {
  return <section id="oferta" className="w-full scroll-mt-16 bg-white/75 px-5 py-14 sm:py-20" data-id="element-244" data-mp="2kvts4sb92n54">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      amount: 0.15
    }} transition={{
      duration: 0.3,
      ease: [0.23, 1, 0.32, 1]
    }} className="mx-auto max-w-[620px]" data-id="element-245" data-mp="1x5ziskq53gpm">
        <h2 className="text-center font-display text-2xl font-bold text-ink sm:text-4xl" data-id="element-246" data-mp="225kduk26v4x2">
          Dzisiaj otrzymujesz cały system
        </h2>

        <div className="mt-8 rounded-2xl border border-chem/20 bg-white p-5 shadow-sm shadow-chem/5 sm:p-7" data-id="element-247" data-mp="1eeosa4obt5y9">
          <ul className="space-y-2.5" data-id="element-248" data-mp="19gdh9qmaopeg">
            {volumes.map(volume => <li key={volume.number} className="flex items-start gap-3" data-id="element-249" data-mp="14pv8t8p5xnbb">
                <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-chem/12 text-chem-deep" data-id="element-250" data-mp="19o6hvh7mvtsh">
                  <CheckIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-251" data-mp="1eemyfa6r3vj2" />
                </span>
                <span className="text-sm leading-relaxed text-ink/85" data-id="element-252" data-mp="1je99pe30r1p8">
                  <span className="font-semibold text-ink" data-id="element-253" data-mp="lq7m4vf07rbf">Tom {volume.number}</span> — {volume.title}
                </span>
              </li>)}
            {bonuses.map(bonus => <li key={bonus.badge} className="flex items-start gap-3" data-id="element-254" data-mp="qpkf7xwgxumg">
                <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-chem/12 text-chem-deep" data-id="element-255" data-mp="vncan1wbnyve">
                  <CheckIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-256" data-mp="znw3ht9v4gbq" />
                </span>
                <span className="text-sm leading-relaxed text-ink/85" data-id="element-257" data-mp="273ajb4nl8iw3">
                  <span className="font-semibold text-ink" data-id="element-258" data-mp="2b3uj6fzjq0lx">{bonus.badge}</span> — {bonus.title}
                </span>
              </li>)}
          </ul>

          <div className="mt-5 grid grid-cols-2 gap-3 border-t border-dashed border-chem/25 pt-5 text-center" data-id="element-259" data-mp="71b3zhwn7bp6">
            <div className="rounded-xl bg-paper px-3 py-3" data-id="element-260" data-mp="l0txb4ksoihf">
              <p className="font-display text-xl font-bold text-chem sm:text-2xl" data-id="element-261" data-mp="l0apwhsrtchn">10</p>
              <p className="mt-1 text-[11px] font-semibold uppercase tracking-[0.1em] text-ink/65" data-id="element-262" data-mp="g2inuuyew9zq">
                Elementów edukacyjnych
              </p>
            </div>
            <div className="rounded-xl bg-paper px-3 py-3" data-id="element-263" data-mp="3kh8qgsu99zi7">
              <p className="font-display text-xl font-bold text-chem sm:text-2xl" data-id="element-264" data-mp="227vfnhgencg">568</p>
              <p className="mt-1 text-[11px] font-semibold uppercase tracking-[0.1em] text-ink/65" data-id="element-265" data-mp="242k9cvuizlt">
                Stron gotowych do wydruku
              </p>
            </div>
          </div>

          <div className="mt-5 flex flex-col items-center rounded-xl bg-chem-soft px-4 py-6 text-center" data-id="element-266" data-mp="35p87lfk8ashy">
            <span className="text-sm font-semibold text-chem-deep" data-id="element-267" data-mp="30qdqci1wtbzy">Twój dzisiejszy dostęp</span>
            <span className="mt-1 font-display text-5xl font-bold text-chem sm:text-6xl" data-id="element-268" data-mp="1g8cprrz4qqtx">
              {PRICE}
            </span>
            <p className="mt-3 text-xs font-medium text-ink/70 sm:text-sm" data-id="element-269" data-mp="17a10bta01z32">
              Jednorazowa płatność • Bez abonamentu • Dostęp cyfrowy od razu
            </p>
          </div>
        </div>

        <div className="mt-6" data-id="element-270" data-mp="1zxn5h5yvlbs1">
          <CTAButton label="Uzyskaj natychmiastowy dostęp" href="https://wizualna-chemia.impultienda.ar/checkout" data-id="element-271" data-mp="1zzhq0j68j1vl" />
          <DailyCountdown data-id="element-272" data-mp="1pzz8e9dsrs6p" />
        </div>
      </motion.div>
    </section>;
}